import io from 'socket.io-client';
import dictionarySearch from '../../dictionary/views/dictionary.html';
import templateMaskLogin from '../views/masklogin.html';
class NavigationController {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdDialog, $transitions, localStorageService, menuHeaderService, NAVIGATION_CONSTANTS, CONSTANTS, authService, $location, matomoEventTrack) {
        $scope.stateChangeDetected = false; $scope.isButtonDisabled=false;
        // matomo analytics code starts
        try {
            $rootScope.$on('$locationChangeSuccess', function (event, current) {
                if (_paq) {
                    // _paq.push(['setDocumentTitle', $rootScope.title]);
                    // _paq.push(['setCustomUrl', $location.path()]);
                    // // _paq.push(['setCustomVariable', 1, "Page Title", $rootScope.title, "page"]);
                    _paq.push(['setCustomDimension', 6, $rootScope.title]);
                    _paq.push(['trackPageView']);
                }
                console.log($rootScope.title+"=========================")
                if ($rootScope.title === "Question paper uploads") {
                    $rootScope.title = "Question Paper Uploads"
                }

                $scope.ga4_measurement_id = CONSTANTS.GOOGLE_ANALYTICS_MEASUREMENT_ID
                gtag('config', $scope.ga4_measurement_id, {
                    'page_title' : $rootScope.title,
                    'page_path': $location.path()
                });

                $rootScope.getNotifications();
            });

            function _webpushrScriptReady(){
                var roleDatasuser = localStorageService.get('role_ids')[0];
                if(roleDatasuser == "student"){ var myrole = "Student"; } else
                if(roleDatasuser == "Rt4ZwrDRxw8Zwer6aC"){ var myrole = "Parent"; }
                else { var myrole = "Employee";  }
                webpushr('attributes',{
                    "email" : localStorageService.get('username'),
                    "full_name" : localStorageService.get('full_name'),
                    "school_name" : localStorageService.get('school_name'),
                     "role_ids" : myrole

                });
             }
             _webpushrScriptReady();

            this.$onInit = () => {
                let   dataEntryUserLogin = false;
                var passCheckStatus =  localStorageService.get("password_tracking");
                if (passCheckStatus) {   $state.go("changePassword"); }
               dataEntryUserLogin = localStorageService.get("dataEntryUserLogin")
            //     if(dataEntryUserLogin){
            //         console.log("yyyaaa");
            //         $state.go('menutile')
            //     }
            }

            $scope.$watch(function () {
                return localStorageService.get('username');
            }, function (newVal, oldVal) {
                userId = newVal;
                if (userId !== undefined && userId !== null && userId !== "") {
                    try {
                        _paq.push(['setUserId', localStorageService.get('username')]);
                        _paq.push(['trackPageView']);
                    } catch (e) {
                        console.log(e)
                    }
                }
            });


        } catch (e) {
            console.log(e)
        }
        //Check Chrome Version Start ......................
        try {
        	var nVer = navigator.appVersion;
        	var nAgt = navigator.userAgent;
        	var browserName = navigator.appName;
        	var fullVersion = '' + parseFloat(navigator.appVersion);
        	var majorVersion = parseInt(navigator.appVersion, 10);
        	var nameOffset, verOffset, ix;

        	// In Chrome, the true version is after "Chrome"
        	if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        		browserName = "chromeCheck";
        		fullVersion = nAgt.substring(verOffset + 7);

        	// trim the fullVersion string at semicolon/space if present
        	if ((ix = fullVersion.indexOf(";")) != -1)
        		fullVersion = fullVersion.substring(0, ix);
        	if ((ix = fullVersion.indexOf(" ")) != -1)
        		fullVersion = fullVersion.substring(0, ix);

        	majorVersion = parseInt('' + fullVersion, 10);
        	if (isNaN(majorVersion)) {
        		fullVersion = '' + parseFloat(navigator.appVersion);
        		majorVersion = parseInt(navigator.appVersion, 10);
        	}

            console.log(majorVersion+"     "+browserName)
            if(majorVersion < 75){
                console.log("Here ............................####")
                var confirm = $mdDialog.confirm()
                .title('Your Chrome version is Outdated ?')
                .textContent('Your current Chrome version is '+majorVersion+'. Please update the latest version 75.0')
                .ariaLabel('chromecheck')
                //.targetEvent(ev)
                .ok('Update Now')
                .cancel('Cancel');

                $mdDialog.show(confirm).then(function () {
                    console.log("Yes.................")
                    window.open("https://www.google.com/chrome/", "_blank");
                }, function () {
                    console.log("No.................")
                });
            }
        }
        } catch (e) {
        	console.log(e)
        }
         //Check Chrome Version End ......................
         var roleDataUserEd = localStorageService.get('role_ids')[0];
         if(roleDataUserEd == "student"){ var myCurrrole = "Student"; } else
         if(roleDataUserEd == "Rt4ZwrDRxw8Zwer6aC"){ var myCurrrole = "Parent"; }
         else { var myCurrrole = "Employee";  }

        $scope.options = {
            ajaxURL: CONSTANTS.NODE_URL + '/v0/userfeedback/' + localStorageService.get('user_id'),
            myRole : myCurrrole
        };

        $scope.backBtnStatus = true;
        $scope.locationPath = CONSTANTS.FILE_UPLOAD_URL;
        $scope.currentImagePath = "../../../../img/header/teacher_profile1.png";
        let userId;
        let bookmarkName


$scope.$watch(function () {
            return localStorageService.get('user_id');
        }, function (newVal, oldVal) {
            userId = newVal;
            if (userId !== undefined && userId !== null && userId !== "") {
                $rootScope.getNotifications();
                //getGmailInboxDetails()
            }
            $scope.isSuparAdmin = false;
            if(localStorageService.get("masked_user")){
                $scope.maskedUserData =  localStorageService.get("masked_user");
            }
            if (localStorageService.get('role_ids').indexOf('super_admin') !== -1 || localStorageService.get('role_ids').indexOf('master_admin') !== -1) {
                $scope.isSuparAdmin = true;
            }
        });
        function backToDashboard(state, oldVal) {
            if (state && state === "quizApiMain" && oldVal && oldVal.name !== "dashboard") {
                $state.go("dashboard")
            }
        }
        /**  Author: Sreeswathy  Description: To find the state change  */
        $transitions.onSuccess({}, function() {
            var passCheckStatus =  localStorageService.get("password_tracking");
            if (passCheckStatus) {   $state.go("changePassword"); }

            $scope.stateChangeDetected = true;
            _.defer(function() {
                isBookmarked($state.$current.name, $state.params);
            });
        });
        $scope.showFeedBack = true
        function disableFeedBackBtn(state = null){
            let NO_FEEDBACK_STATES = ['studentQuestionSelection']
            $scope.showFeedBack = true
            try{
                if(state){
                    if(NO_FEEDBACK_STATES.indexOf(state) !== -1){
                        $scope.showFeedBack = false
                    }
                }
            }catch(e2){
                console.log(e2)
                $scope.showFeedBack = true
            }
        }
        $scope.$watch(function () {
            return $state.$current
        }, function (newVal, oldVal) {
            let state = newVal.name;
            try{
                disableFeedBackBtn(state)
            }catch(e1){
                console.log(e1)
                $scope.showFeedBack = true
            }
            if (state === "dashboard") {
                $scope.backBtnStatus = false;
            } else {
                $scope.backBtnStatus = true;
            }
			userId = localStorageService.get('user_id')
            let nonAuthoringStates = ['dashboard', 'menutile', 'myProfile', 'aboutUs', 'viewUserManual', 'notifications','learningTracker', "learningOutcomeTracker", 'gridView', 'prevReportEditCtrl',
            'activityExportCtrl', 'classTeacherReportCtrl', 'questionPaperCtrl', 'qpPrincipalCtrl', 'viewqpPrincipalCtrl', 'questionPaperTeacherCtrl'];
            if (!nonAuthoringStates.includes(state)) {
                let authoringDetails = localStorageService.get("authoringData");
                if (authoringDetails) {
                    $rootScope.authMenu = true;
                    let title = ''
                    if(authoringDetails.class && authoringDetails.class && authoringDetails.batch && authoringDetails.curriculum && authoringDetails.session){
                        title = authoringDetails.class + "" + authoringDetails.batch + "/" + authoringDetails.curriculum + "/" + authoringDetails.session + "/" + authoringDetails.subject;
                    }
                    $rootScope.title = title
                }
            } else {
                $rootScope.authMenu = false;
            }
            backToDashboard(state, oldVal)
            setMoreOptions();
            let urlState = newVal.self.url.split('/')[1];
            localStorageService.set('current_Page', urlState);
            if (!$scope.stateChangeDetected) {
                isBookmarked(state, $state.params);
            }
            if (localStorageService.get('login_timestamp')) {
                if (new Date().getTime() - localStorageService.get('login_timestamp') >= 18000000) {
                    toastr.error('Session Expired. Please login again to continue');
                    $scope.logout();
                }
            } else {
                // toastr.error('Session Expired. Please login again to continue');
                $scope.logout();
            }
        });

        if (localStorageService.get("current_Page") == "dashboard" || localStorageService.get("current_Page") === "parentPortalHome") {
            $scope.backBtnStatus = false;
        } else {
            $scope.backBtnStatus = true;
        }

        if (localStorageService.get("full_name")) {
            $rootScope.username = localStorageService.get("full_name");
        }

        //To set authoring tool menu
        $scope.menuService = menuHeaderService
        $scope.directToMyprofile = function () {
            localStorageService.set('FROMSEARCH', "false");
            $state.go('myProfile');
        }

        /******************* Bookmark Functions - START ***********************/

        function isBookmarked(stateName, stateParams) {
            $scope.isShowBookmark = false;
            $scope.bookmark = undefined
            if (stateName && $rootScope.authMenu && localStorageService.get('authoringData')) {
                let authoringData = localStorageService.get('authoringData')
                if (authoringData) {
                    let academic_details = {
                        session_id: authoringData.session_id,
                        curriculum_id: authoringData.curriculum_id,
                        batch_id: authoringData.batch_id,
                        class_id: authoringData.class_id,
                        subject_id: authoringData.subject_id,
                        school_id: authoringData.school_id
                    }
                    let current_academic_year = authoringData.academic_year
                    let state_param = stateParams;
                    let objKeys = Object.keys(state_param)
                    if (objKeys[0] === "#") {
                        delete state_param["#"]
                    }
                    let params = {
                        academic_details: academic_details,
                        academic_year: current_academic_year,
                        user_id: localStorageService.get("user_id"),
                        state: stateName,
                        params: state_param
                    }
                    authService.callAPI(NAVIGATION_CONSTANTS.API_IS_BOOKMARK, 'POST', params, function (response) {
                        if (response && response.result && response.result.data) {
                            if (response.result.data.isBookmarked) {
                                $scope.isBookmarked = true;
                                $scope.bookmark = response.result.data.data
                            } else {
                                $scope.isBookmarked = false;
                            }
                        }
                        _.defer(function () {
                            $scope.$apply();
                        });
                    });
                }
            }
        }
        $scope.closeBookmark = () => {
            $scope.isShowBookmark = false;
        }
        $scope.addBookmark = () => {
            $scope.isShowBookmark = true;
            if ($scope.bookmark)
                $scope.navigation.bookmarkTitle = $scope.bookmark.title
            else
                $scope.navigation.bookmarkTitle = undefined
        }
        $scope.saveBookmark = () => {
            if ($scope.navigation.bookmarkTitle) {
                $scope.isShowBookmark = false;
                if ($scope.isBookmarked) {
                    if ($scope.bookmark.title !== $scope.navigation.bookmarkTitle) {
                        let params = {
                            bookmark_id: $scope.bookmark._id,
                            bookmark_title: $scope.navigation.bookmarkTitle,
                            user_id: localStorageService.get("user_id")
                        }
                        authService.callAPI(NAVIGATION_CONSTANTS.API_UPDATE_BOOKMARK, 'POST', params, function (response) {
                            if (response && response.result && response.result.data) {
                                $scope.bookmark.title = $scope.navigation.bookmarkTitle;
                                $scope.isBookmarked = true;
                                toastr.success("Bookmark added")
                            }
                            _.defer(function () {
                                $scope.$apply();
                            });
                        });
                    }
                } else {
                    let authoringData = localStorageService.get("authoringData")
                    let academic_details
                    if (authoringData) {
                        academic_details = {
                            session_id: authoringData.session_id,
                            curriculum_id: authoringData.curriculum_id,
                            batch_id: authoringData.batch_id,
                            class_id: authoringData.class_id,
                            subject_id: authoringData.subject_id,
                            school_id: authoringData.school_id
                        }
                    }
                    let session_details = []
                    localStorageService.keys().forEach(function (key) {
                        let value = localStorageService.get(key)
                        session_details.push({
                            key: key,
                            value: value
                        })
                    })
                    let params = $state.params;
                    let objKeys = Object.keys(params)
                    if (objKeys[0] === "#") {
                        delete params["#"]
                    }
                    let state_details = {
                        name: $state.current.name,
                        params: $state.params
                    }
                    let bookmark = {
                        bookmark_title: $scope.navigation.bookmarkTitle,
                        academic_details: academic_details,
                        session_details: session_details,
                        state_details: state_details,
                        academic_year: authoringData.academic_year,
                        user_id: localStorageService.get("user_id")
                    }
                    authService.callAPI(NAVIGATION_CONSTANTS.API_ADD_BOOKMARK, 'POST', bookmark, function (response) {
                        if (response && response.result && response.result.data) {
                            toastr.success("Bookmark added");
                            $scope.isBookmarked = true;
                            $scope.bookmark = response.result.data.info
                        }
                        _.defer(function () {
                            $scope.$apply();
                        });
                    });
                }
            } else {
                $scope.bookmarkError = "Please enter the bookmark title";
            }
        }
        $scope.removeBookmark = () => {
            $scope.isShowBookmark = false;
            authService.callAPI(NAVIGATION_CONSTANTS.API_DELETE_BOOKMARK + $scope.bookmark._id, 'GET', {}, function (response) {
                if (response) {
                    toastr.success("Bookmark is deleted successfully")
                    $scope.isBookmarked = false
                    $scope.bookmark = undefined;
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }

        /******************* Bookmark Functions - END ***********************/

        /* Notifications NodeJS migration. Restrict to recent notifications */
        $rootScope.getNotifications = function () {
            let appName = 'educore';
            authService.callAPI(NAVIGATION_CONSTANTS.API_GET_NOTIFICATION_HEADER_DETAILS + userId + '/' + appName, "GET", {}, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.notifications = response.result.data.details.recentNotifications;
                        $scope.notificationCounts = response.result.data.details.unreadCount;
                        if ($scope.notifications.length >= 1) {
                            _.each($scope.notifications, function (eachNotify) {
                                eachNotify.clickStatus = 'active'
                                if (eachNotify.notification_status != undefined) {
                                    _.each(eachNotify.notification_status, function (user_details) {
                                        if (user_details.user_id === userId){
                                            eachNotify.notificationClicked = true;
                                            eachNotify.clickStatus = 'inactive'
                                        }
                                    });
                                };
                            });
                        } else {
                            $scope.noNotifications = true;
                        }
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    //toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
            authService.callAPI(NAVIGATION_CONSTANTS.API_GET_USER_DETAILS + userId, 'GET', {}, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.currentUser = response.result.data.details;
                        let st_admission_number = localStorageService.get("st_admission_number")
                        if(!st_admission_number && $scope.currentUser && $scope.currentUser.admission_number){
                            localStorageService.set("st_admission_number", $scope.currentUser.admission_number)
                        }
                        $rootScope.email = $scope.currentUser.username;
                    } catch (ex) {
                        console.log(ex)
                    }
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });

            /* Added Socket Communication */
            // const socket = io(CONSTANTS.NODE_SOCKET_URL + "/notify?username=" + userId);
            // socket.on('getNotification', function (data) {
            //     if (data.notification_status != undefined) {
            //         _.each(data.notification_status, function (user_details) {
            //             if (user_details.user_id === userId)
            //                 data.notificationClicked = true;
            //         });
            //     };
            //     $scope.notifications.unshift(data);
            //     $scope.notificationCounts++;
            //     _.defer(function () {
            //         $scope.$apply();
            //     });
            // });
        }

        $scope.goDashboard = () => {
            $state.go('dashboard')
        }

        $scope.goMenu = () => {
            $state.go('menutile')
        }

        $scope.goHome = () => {
            $state.go('dashboard')
        }

        $scope.goBack = () => {
            if ($state.current.name == "myStudentsList") {
                localStorageService.set('searchSession', undefined)
            }
            if ($state.current.name == "questionPaperCtrl") {
                console.log($rootScope.title, "???????");
                
                if ($rootScope.title == "Question Paper Uploads - HOD") {
                    $rootScope.title = "Question Paper Uploads"
                }
                if ($rootScope.title == "Question Paper Uploads - Teacher") {
                    $rootScope.title = "Question Paper Uploads"
                }
                $rootScope.title = "Question Paper Uploads"
            }
            if ($state.current.name == 'qpSummary' && $scope.currentUser.role_ids[0] == 'student')
                $state.go("dashboard")
            else
                window.history.back();
        }

        $scope.logout = () => {
			$rootScope.count = 0
            $rootScope.isLoggedIn = false
            $rootScope.authMenu = false
            localStorageService.set("login_det", null)
            localStorage.clear()
            localStorageService.set("gLongin", '1')


            // matomo analytics code starts
            try {
                _paq.push(['resetUserId']);
                _paq.push(['trackPageView']);
            } catch (e) {
                console.log(e);
            }
            // matomo analytics code ends

            $state.go('login', {}, {
                reload: true
            })
        }

        $scope.openMenuAll = ($mdOpenMenu, ev) => {
            let originatorEv = ev;
            $mdOpenMenu(ev);
        }

        $scope.dictionarySearch = () => {
            $mdDialog.show({
                controller: DictionaryController,
                template: dictionarySearch,
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                escapeToClose: true
            })
        }

        function DictionaryController($scope, $mdDialog, $timeout) {
            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.triggersubmit = function () {
                $timeout(function () {
                    angular.element('#dicbtn').triggerHandler('click');
                    document.querySelector("#dicbtn").focus();
                });
            }

            $scope.getsearchData = (dictionary) => {
                $scope.dictionaryItems = []
                document.getElementById("issearchimg").style.display = "block";
                if (dictionary && dictionary.searchkey) {
                    let searchword = dictionary.searchkey.toLowerCase();
                    authService.callAPI(NAVIGATION_CONSTANTS.API_GET_DICTIONARY_SEARCH + searchword, 'GET', {}, function (response) {
                        if (response.result && response.result.data && response.result.data.result) {
                            try {
                                let result = response.result.data.result;
                                if (result == "DB error") {
                                    toastr.error('Server connection error');
                                }
                                else if (result == "No data") {
                                    toastr.error('No data found in Dictionary. try some other word.');
                                }
                                else {
                                    $scope.dictionaryItems = []
                                    _.each(result[0].meaning, function (dataObj) {
                                        _.each(dataObj, function (datameanObj) {
                                            $scope.dictionaryItems.push(datameanObj.definition)
                                        });

                                    });
                                }
                            } catch (ex) {
                                console.log(ex)
                            }
                        } else {
                            //toastr.error('Something went error !Please try after sometime')

                        }
                        document.getElementById("search_dc").focus()
                        document.getElementById("issearchimg").style.display = "none";

                        _.defer(function () {
                            $scope.$apply();
                        });
                    });
                } else {
                    toastr.error('Please enter some word for search.')
                    document.getElementById("issearchimg").style.display = "none";
                }
            }
        }

        $scope.moreOptionList = [{
            name: 'Forum',
            stateName: 'forumList',
            _id: 'forum',
            accessPermission: false,
            iconUrl: '../../../img/icons/header-icons/forum.png'
        }, {
            name: 'FAQ',
            stateName: 'faq',
            _id: 'faq',
            accessPermission: false,
            iconUrl: '../../../img/icons/header-icons/faq.png'
        }, {
            name: 'Chat',
            stateName: 'chat',
            _id: 'chat',
            accessPermission: false,
            iconUrl: '../../../img/icons/header-icons/chat.png'
        },
        {
            name: 'Activity',
            stateName: 'activityList',
            _id: 'activityList',
            accessPermission: false,
            iconUrl: '../../../img/icons/header-icons/activity-side-nav.png'
        }, {
            name: 'Set Target',
            stateName: 'studentSetTarget',
            _id: 'studentSetTarget',
            accessPermission: false,
            iconUrl: '../../../img/icons/header-icons/set-target.png'
            // }, {
            //     name: 'Survey',
            //     stateName: 'surveyList',
            //     _id: 'commonSurveyList',
            //     accessPermission: false,
            //     iconUrl: '../../../img/icons/header-icons/survey.png'
        }, {
            name: 'Bookmark',
            stateName: 'bookmark',
            _id: 'bookmark',
            accessPermission: false,
            iconUrl: '../../../img/icons/header-icons/bookmark.png'
        }, {
            name: 'Digital Library [Archives]',
            stateName: 'archives',
            _id: 'archives',
            accessPermission: false,
            iconUrl: '../../../img/icons/header-icons/archives.png'
            // }, {
            //     name: 'View note',
            //     stateName: 'viewnote',
            //     _id: 'viewnote',
            //     accessPermission: false,
            //     iconUrl: '../../../img/icons/header-icons/view-note.png'
        }, {
            name: 'Send',
            stateName: 'send',
            _id: 'send',
            accessPermission: false,
            iconUrl: '../../../img/icons/header-icons/SEND.png'
        }, {
            name: 'G&T',
            stateName: 'giftedTalented',
            _id: 'giftedTalented',
            accessPermission: false,
            iconUrl: '../../../img/icons/header-icons/G-and-T.png'
        }, {
            // name: 'Mark Entry',
            // stateName: 'examListingPage',
            // _id: 'examMarkEntryList',
            // accessPermission: false,
            // iconUrl: '../../../img/icons/header-icons/mark-entry.png'
        }, {
            name: 'Mark Entry Sheet',
            stateName: 'markEntrySheet',
            _id: 'examMarkEntryList',
            accessPermission: false,
            iconUrl: '../../../img/icons/header-icons/mark-entry.png'
        }, {
            name: 'Set Target',
            stateName: 'setTarget',
            _id: 'setTarget',
            accessPermission: false,
            iconUrl: '../../../img/icons/header-icons/set-target.png'
        }, {
            name: 'Report Cards',
            stateName: 'reportCardListing',
            _id: 'reportCardListing',
            accessPermission: false,
            iconUrl: '../../../img/icons/header-icons/report-card.png'
        }, {
            name: 'Buddy',
            stateName: 'buddyDashboard',
            _id: 'buddyDashboard',
            accessPermission: false,
            iconUrl: '../../../img/icons/header-icons/buddy.png'
        }, {
            name: 'Student Report Cards',
            stateName: 'studentListingForReports',
            _id: 'studentListingForReports',
            accessPermission: false,
            iconUrl: '../../../img/icons/header-icons/report-card.png'
        }, {
            name: 'Holistic Reports Sheet',
            stateName: 'HpcSheetController',
            _id: 'HpcSheetController',
            accessPermission: false,
            iconUrl: '../../../img/icons/header-icons/mark-entry.png'
        }
        ]

        //To update menu list
        function setMoreOptions() {
            let module_privileges = localStorageService.get("module_privileges")
            if (module_privileges) {
                _.each($scope.moreOptionList, function (option) {
                    let moduleIndex = module_privileges.findIndex(i => i.state == option._id)
                    if (moduleIndex !== -1) {
                        option.accessPermission = true;
                    }
                })

                // HPC visibility: only show when the selected class is a KG class (KG1 / KG2)
                const KG_CLASS_NAMES = ['KG1', 'KG2']
                const authoringData  = localStorageService.get('authoringData')
                const isKgClass      = authoringData && KG_CLASS_NAMES.indexOf(authoringData.class) !== -1
                const reportCardOption = _.find($scope.moreOptionList, function (o) { return o._id === 'reportCardListing' })
                const hpcOption        = _.find($scope.moreOptionList, function (o) { return o._id === 'HpcSheetController' })
                if (reportCardOption && hpcOption) {
                    hpcOption.accessPermission = reportCardOption.accessPermission && isKgClass
                }
            }
        }

        //To navigate to module
        $scope.navigateModule = function (state, object) {
            // if (state === "surveyList") {
            //     const mongoose = require('mongoose');
            //     $state.go(state, {
            //         user_id: userId,
            //         schedule_id: new mongoose.Types.ObjectId().toString(),
            //         is_fpi_survey: false
            //     });
            // } else {
            $state.go(state)
            // }
        }

        $scope.openNotificationMenu = function ($mdOpenMenu, ev) {

            // matomo track event starts
            matomoEventTrack.pushEvent('Navigation', 'Notification', "Icon Click", 1)
            // matomo track event ends

            authService.callAPI(NAVIGATION_CONSTANTS.API_UPDATE_NOTIFICATION_TRACKER, "PUT", {
                user_id: userId
            }, function (response) {
                if (response.result && response.result.data && response.result.data.message) {
                    try {
                        $scope.notificationCounts = 0;
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    //toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
            $mdOpenMenu(ev);
        }

        /*
         * To navigate to notifications page
         *
         * @return: null
         */
        $scope.goToNotificationsPage = function () {
            $state.go('notifications')
        }

        /*
        * To close all popups
        *
        * @return : null
        */
        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        /*
         * To navigate to corresponding pages (un-optimised)
         *
         * @notification: Object - Holds notification details
         *
         * @return : null
         */
        $scope.routeToPage = function (notification) {
			console.log(notification,"99999999999");
            let reqObj = {
                user_id: userId,
                notification_id: notification._id
            }
            authService.callAPI(NAVIGATION_CONSTANTS.API_UPDATE_NOTIFICATION_STATUS, "PUT", reqObj, function (response) {
                if (response.result && response.result.data && response.result.data.message) { } else {
                    $scope.cancel();
                   // toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
            var roleList = []
            if (notification.references && notification.references.academic_details) {
                var academics = notification.references.academic_details
                authService.callAPI(NAVIGATION_CONSTANTS.API_GET_PERSON_DETAILS + userId, "GET", {}, function (response) {
                    if (response.result && response.result.data && response.result.data.details) {
                        try {
                            let userDetails = response.result.data.details
                            if (userDetails.details) {
                                let classDetails = userDetails.details
                                var curriculumData = _.find(classDetails, function (obj) {
                                    return obj.class_id === academics.class_id && obj.curriculum_id === academics.curriculum_id && obj.batch_id === academics.batch_id && obj.session_id === academics.session_id
                                })
                                if (curriculumData && curriculumData.subjects) {
                                    var subject = _.find(curriculumData.subjects, function (data) {
                                        return data === academics.subject_id
                                    })
                                    if (subject) {
                                        localStorageService.set('multiRoles', userDetails.role_ids)
                                        roleList = userDetails.role_ids
                                    }
                                }
                            }
                            if (userDetails.details === undefined || curriculumData === undefined || curriculumData.subjects === undefined || subject === undefined) {
                                roleList = fetchRoleFromCoursewareDetails(userDetails, academics)
                                if (roleList === undefined)
                                    roleList = []
                                localStorageService.set('multiRoles', roleList)
                            }
                        } catch (ex) {
                            console.log(ex);
                        }
                    } else {
                        $scope.cancel();
                       // toastr.error('Network Error. Please try later');
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            }

            self.notificationCounts = 0;
            $rootScope.notif_id = null;
			console.log(roleList,"----------55555555----------");
            if (roleList) {

                switch (parseInt(notification.type)) {
                    case 600:
                        $state.go('commonSurveyList', {
                            user_id: userId,
                            schedule_id: notification.references.schedule_id,
                            is_fpi_survey: notification.references.is_fpi_survey
                        })
                        break;
                    case 601:
                        if (notification.references != undefined) {
                            $state.go('listSurveyAnswer', {
                                surveyId: notification.references.survey_id,
                                parent_state: notification.references.parent_state,
                                user_id: userId,
                                schedule_id: notification.references.schedule_id,
                                is_fpi_survey: notification.references.is_fpi_survey
                            })
                        }
                        break;
                    case 100:
                        $rootScope.notif_id = notification._id;
                        $state.go('viewDictation');
                        break;
                    case 101:
                        if (userData.role_ids.indexOf('student') !== -1) {
                            $state.go('studentNewAssignmentView', {
                                "getAssginmentQuestion": notification.title,
                                "assignment_id": notification.references,
                                "question_id": notification.references
                            });
                        } else
                            $state.go('assignment');
                        break;
                    case 102:
                        if (self.getNotification && Notifications.find({}).fetch().length > 0) {
                            for (var i = 0; i < self.getNotification.data.length; i++) {
                                //Check nofication data have the the current user
                                //---START---
                                if (self.getNotification.data[i].student_id === userId) {
                                    //Check onexam is true for current user
                                    //if condition start
                                    if (!self.getNotification.data[i].onExam) {
                                        if (userData.role_ids.indexOf('student') !== -1) {
                                            let quizObj = {
                                                "teacher_id": notification.sender_id,
                                                "quiz_id": notification.references,
                                                'type': "assessment"
                                            }
                                            if (notification.references.subject_id != undefined) {
                                                localStorageService.set("subjectId", notification.references.subject_id)
                                                localStorageService.set("classId", notification.references.class_id)
                                                localStorageService.set("batchId", notification.references.batch_id)
                                                localStorageService.set("sessionId", notification.references.session_id)
                                                localStorageService.set("curriculumId", notification.references.curriculum_id)
                                            }
                                            $state.go('assessmentList');
                                        } else {
                                            $state.go('teacherAssessmentList');
                                            if (notification.references.subject_id != undefined) {
                                                localStorageService.set("subjectId", notification.references.subject_id)
                                                localStorageService.set("classId", notification.references.class_id)
                                                localStorageService.set("batchId", notification.references.batch_id)
                                                localStorageService.set("sessionId", notification.references.session_id)
                                                localStorageService.set("curriculumId", notification.references.curriculum_id)
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        break;
                    case 103:
                        if (userData.role_ids.indexOf('student') !== -1)
                            $state.go('studentDrawingView', {
                                "getAssginmentQuestion": notification.references,
                                "assignment_id": notification.references,
                                "question_id": notification.references
                            });
                        else
                            $state.go('drawingAssignmentList');
                        break;
                    case 104:
                        $state.go('addAvailability');
                        break;
                    case 105:
                        if (self.getNotification && Notifications.find({}).fetch().length > 0) {
                            for (var i = 0; i < self.getNotification.data.length; i++) {
                                //Check nofication data have the the current user
                                //---START---
                                if (self.getNotification.data[i].student_id === userId) {
                                    //Check onexam is true for current user
                                    //if condition start
                                    if (!self.getNotification.data[i].onExam) {
                                        if (userData.role_ids.indexOf('student') !== -1) {
                                            let quizObj = {
                                                "teacher_id": notification.sender_id,
                                                "quiz_id": notification.references,
                                                'type': "quiz"
                                            }
                                            if (notification.references.subject_id != undefined) {
                                                localStorageService.set("subjectId", notification.references.subject_id)
                                                localStorageService.set("classId", notification.references.class_id)
                                                localStorageService.set("batchId", notification.references.batch_id)
                                                localStorageService.set("sessionId", notification.references.session_id)
                                                localStorageService.set("curriculumId", notification.references.curriculum_id)
                                            }
                                            $state.go('quizList');
                                        } else
                                            $state.go('questionList');
                                    }
                                }
                            }
                        }
                        break;
                    case 107:
                        $state.go('facultySearchFilter');
                        break;
                    case 109:
                        QuestionsFactory.addEyfsId(notification.references._id)
                        $state.go('studentReportView', {
                            "getTeachingPlan": notification.references
                        });
                        break;
                    case 200:
                        $state.go('facultyEvaluationFilter');
                        break;
                    case 201:
                        $state.go('hosOwnDashboard');
                        break;
                    case 202:
                        //FPI points noti for teacher
                        $state.go('myDashboard');
                        break;
                    case 203:
                        //FPI points dispute request from teacher to Princi
                        $state.go('pointsObservation');
                        break;
                    case 204:
                        //FPI points dispute approve/reject to teacher from Princi
                        $state.go('myDashboard');
                        break;
                    case 205:
                        //FPI report submission to Principal
                        $state.go('criteriaApproval');
                        break;
                    case 206:
                        //FPI published report to Teacher
                        $state.go('fpiEvaluationReport', {
                            "faculty_id": notification.references.faculty_id,
                            "schedule_id": notification.references.schedule_id,
                            "faculty_role_id": notification.references.faculty_role_id
                        });
                        break;
                    case 211:
                        //FPI Rejected Self Evaluation
                        $state.go('myDashboard');
                        break;
                    case 208:
                        //FPI Rejected Criteria Reports
                        $state.go('facultyDashboard', {
                            "faculty_id": notification.references.faculty_id,
                            "faculty_role_id": notification.references.faculty_role_id
                        });
                        break;
                    case 207:
                        //HOS Uploaded Document to Principal
                        $state.go("hosDashboard", {
                            "faculty_id": notification.references.user_id,
                            "faculty_role_id": notification.references.role_id
                        })
                        break;
                    case 209:
                        //Teacher' dashboard at Principal/HOD/HOS
                        $state.go("fpiPointsTeacher", {
                            "f_id": notification.references.faculty_id
                        })
                        break;
                    case 210:
                        //For HOS criteria
                        $state.go("hosOwnDashboard");
                        break;
                    case 300:
                        //Mark entry approval request to class teacher- updated - Developer : Shereen
                        localStorageService.set("authoringData", notification.references.authoringData)
                        menuHeaderService.setAuthMenu()
                        $state.go('classteacherApproval');
                        break;
                    case 301:
                        //Mark entry approve/reject to subject teacher
                        if (notification.references.subject_id != undefined) {
                            localStorageService.set("subjectId", notification.references.subject_id)
                            localStorageService.set("classId", notification.references.class_id)
                            localStorageService.set("batchId", notification.references.batch_id)
                            localStorageService.set("sessionId", notification.references.session_id)
                            localStorageService.set("curriculumId", notification.references.curriculum_id)
                            localStorageService.set("authoringData", notification.references)
                        }
                        menuHeaderService.setAuthMenu()
                        $state.go('examListingPage');
                        break;
                    case 500:
                        //Mark entry approve/reject to subject teacher
                        $state.go('peopleLookUp', {
                            "user_id": notification.references.user_id
                        });
                        break;
                    case 400:
                        // SEND Teacher notification
                        $state.go('senWaveProcess', {
                            studentDetails: notification.references
                        });
                        break;
                    case 401:
                        // SEND CO Ordinator notification redirect page
                        $rootScope.notif_id = notification._id;
                        $state.go('studentProfileView', {
                            studentDetails: notification.references
                        });
                        break;
                    case 402:
                        // SEND Counselor & SEND Educator notification
                        $state.go('studentProfileView', {
                            studentDetails: notification.references
                        });
                        break;
                    case 403:
                        // SEND Parent notification
                        $rootScope.notif_id = notification._id;
                        $state.go('parentChildSenPage', {
                            studentDetails: notification.references
                        });
                        break;
                    case 404:
                        // SEND Counselor notification
                        $state.go('studentProfileView', {
                            studentDetails: notification.references
                        });
                        break;
                    case 800:
                        // Availability notification for parent
                        $state.go('getAvailability');
                        break;
                    case 801:
                        // Availability notification for parent
                        $state.go('reassignAvailability');
                        break;
                    /*medical start*/
                    case 1000:
                        $state.go('userProgramList');
                        break;
                    case 1001:
                        userIdArray = []
                        userIdArray.push({
                            user_id: notification.references.patient_id
                        })
                        localStorageService.set('selectedUsers', userIdArray)
                        $state.go('medicalUserProfile');
                        break;
                    case 1002:
                        userIdArray = []
                        userIdArray.push({
                            user_id: notification.references._id
                        })
                        localStorageService.set('selectedUsers', userIdArray)
                        $state.go('medicalUserProfile');
                        break;
                    case 1004:
                        $state.go('medicalDashboard');
                        break;
                    case 1011:
                        $state.go('userProgramList');
                        break;
                    case 1012:
                        localStorageService.set('st_id', notification.references)
                        $state.go('childProfile');
                        break;
                    /*medical ends*/
                    case 700:
                        //Club Activities -Developed by: Shereen
                        if (notification.references) {
                            localStorageService.set("isClubOwnerID", notification.references.owner_id)
                            localStorageService.set("selectedClubId", notification.references.club_id)
                            $state.go('clubPost');
                        }
                        break;
                    case 777:
                        //for ASL activity
                        ASLFactory.addCategory(notification.references)
                        $state.go('aslList');
                        break;
                    case 3100:
                        $state.go('announcements');
                        break;
                    case 3200:
                        $state.go('announcements');
                        break;
                    case 1500:
                        // $state.go('cpdSections');
                        $state.go('cpdSections', {
                            viewReq: "new"
                        })
                        break;
                    case 2001:
                        $state.go('approverTeachingPlanView', {
                            "getTeachingPlan": notification.references._id
                        });
                        break;
                    case 2002:
                        $state.go("calendar")
                        break;
                    case 6001:
                        //Report card creation
                        $state.go('showReportCards');
                        break;
                    case 6002:
                        // localStorageService.set("authoringData", notification.references.academic_details)
                        $state.go('publishedReports', {
                            "student_id": localStorageService.get('user_id'),
                            "fee_status": false
                        });
                        break;
                    case 6003:
                        $state.go('publishedReports', {
                            "student_id": notification.references.student_id,
                            "fee_status": false
                        });
                        break;
                    case 110:
                        localStorageService.set("authoringData", notification.references)
                        localStorageService.set("chat_subjectId", notification.references.subject_id)
                        localStorageService.set("chat_classId", notification.references.class_id)
                        localStorageService.set("chat_batchId", notification.references.batch_id)
                        localStorageService.set("chat_sessionId", notification.references.session_id)
                        localStorageService.set("chat_curriculumId", notification.references.curriculum_id)

                        localStorageService.set("chat_schoolId", notification.references.school_id)
                        menuHeaderService.setAuthMenu()
                        $state.go('chat');
                        break;
                    case 111:
                        localStorageService.set("authoringData", notification.references.academic_details)
                        menuHeaderService.setAuthMenu()
                        $state.go('forumList');
                        break;
                    case 112:
                        localStorageService.set("authoringData", notification.references.academic_details)
                        menuHeaderService.setAuthMenu()
                        $state.go('faq');
                        break;
                    case 7001:
                        //Survey -authoring tool - Developed by : Shereen
                        localStorageService.set("authoringData", notification.references.academic_details)
                        menuHeaderService.setAuthMenu()
                        $state.go("attemptSurvey", {
                            "surveyId": notification.references
                        })
                        break;
                    case 7005:
                        localStorageService.set("authoringData", notification.references.academic_details)
                        menuHeaderService.setAuthMenu()
                        $state.go("viewGeneratedReportData", {
                            "dataId": notification.references._id,
                            "selected_year": notification.references.selected_year,
                            is_edit : false
                        })
                        break;
                    case 7007:
                        localStorageService.set("authoringData", notification.references.academic_details)
                        menuHeaderService.setAuthMenu()
                        $state.go("reportCardListing")
                        break;
                    case 7006:
                        localStorageService.set("authoringData", notification.references.academic_details)
                        menuHeaderService.setAuthMenu()
                        $state.go("viewGeneratedReportData", {
                            "dataId": notification.references._id,
                            "selected_year": notification.references.selected_year,
                            is_edit : false
                        })
                        break;
                    case 444:
                        notification.references.academic_details.academic_year = localStorageService.get('academic_year');
                        localStorageService.set("authoringData", notification.references.academic_details)
                        if (notification.references && notification.references.res_ids)
                            localStorageService.set("approverResourceIds", notification.references.res_ids)
                        $state.go('viewTeachingPlan', {
                            planId: notification.references.tp_id
                        })
                        break;
                    case 3001:
                        localStorageService.set("notifyData", notification.references)
                        menuHeaderService.setAuthMenu()
                        $state.go('send');
                        break;
                    case 3003:
                        localStorageService.set("notifyData", notification.references)
                        menuHeaderService.setAuthMenu()
                        $state.go('giftedTalented');
                        break;
                    case 3004:
                        localStorageService.set("notifyData", notification.references)
                        $state.go('buddyDashboard');
                        break;
                    case 3005:
                        localStorageService.set("authoringData", notification.references.academic_details)
                        $state.go('viewnote');
                        break;
                    case 555:
                        notification.references.academic_details.academic_year = localStorageService.get('academic_year');
                        localStorageService.set("authoringData", notification.references.academic_details)
                        $state.go('activityFormPreview', {
                            "planId": notification.references.tp_id,
                            "resourceId": notification.references.activity_id
                        });
                        break;
                    case 1100:
                        //Set Target- Developed by: Shereen
                        localStorageService.set("authoringData", notification.references.academic_details)
                        menuHeaderService.setAuthMenu()
                        $state.go('setTarget', {});
                        break;
                    case 1101:
                        if (notification.references.type === "sendForApproval") {
                            $state.go("approveArchive")
                        }
                        if (notification.references.type === "approved") {
                            $state.go("myArchives")
                        }
                        break;
                    case 333:
                        localStorageService.set("authoringData", notification.references.academic_details)
                        $state.go('qpSummary', {
                            qpId: notification.references.qp_id
                        })
                        break;
                    case 190:
                        $state.go('approveAppList')
                        break;
                    case 191:
                        localStorageService.set("st_id", notification.references.student_id)
                        $state.go('tabletDetailsofChild')
                        break;
                    case 1102:
                        $state.go('viewSyllabus', {
                            syllabusId: notification.references.syllabus_id
                        });
                        break;
                    case 4000:
                        $state.go('userApproval')
                        break;
                    case 4001:
                        $state.go('recieverFeedbackList')
                        break;
                    case 4002:
                        $state.go('parentFeedback')
                        break;
                    case 7698:
                        localStorageService.set("authoringData", notification.references.academic_details)
                        menuHeaderService.setAuthMenu()
                        $state.go('multipleReportsSelectionCtrl');
                        break;
                    case 955:
                        $state.go('greetingsView')
                        break;
                    default:
                        $state.go("notifications", {}, { reload: true })
                        break;
                    case 956:
                        $state.go('lessonView',
                        { _id: notification.references.lo_id }
                    )
                    case 960:
                        $state.go('lessonView',
                        { _id: notification.references.lo_id }
                    )
                    break;
                    case 957:
                        $state.go('learningView',
                        { _id: notification.references.lo_id }
                    )
                    break;
                    case 958:
                        $state.go('myStudentsList')
                    break;
                    case 959:
                        $state.go('leaveManagement')
					case 3000:
						$state.go('learningwalkview',
                        { lw_id: notification.references.lw_id ? notification.references.lw_id : notification.references }
                    )
                    break;
                    case 3010:
						$state.go('learningwalkview',
                        { lw_id: notification.references.lw_id ? notification.references.lw_id : notification.references }
                    )
                    break;
                }
            }
        }

        function fetchRoleFromCoursewareDetails(UserDetails, academics) {
            if (UserDetails.courseware_details) {
                let coursewareList = []
                var coursewareObj = UserDetails.courseware_details; // courseware details of logged in user
                if (coursewareObj.sendObj) {
                    _.each(coursewareObj.sendObj, function (each) { //for sendObj
                        coursewareList.push(each)
                    })
                }
                if (coursewareObj.traditional_activity_approval) {
                    _.each(coursewareObj.traditional_activity_approval, function (each) { //for sendObj
                        if (each) {
                            coursewareList.push(each)
                        }
                    })
                }
                if (coursewareObj.teaching_plan_approval) {
                    _.each(coursewareObj.teaching_plan_approval, function (each) { //for sendObj
                        coursewareList.push(each)
                    })
                }
                if (coursewareObj.teaching_plan_sharing) {
                    _.each(coursewareObj.teaching_plan_sharing, function (each) { //for sendObj
                        coursewareList.push(each)
                    })
                }
                if (coursewareObj.notes_sharing) {
                    _.each(coursewareObj.notes_sharing, function (each) { //for sendObj
                        coursewareList.push(each)
                    })
                }
                //for setTarget to get courseware details for parent- Developer: Shereen - Date : 12/12/2017
                if (coursewareObj.set_target_obj) {
                    _.each(coursewareObj.set_target_obj, function (each) {
                        coursewareList.push(each)
                    })
                }
                //If the class teacher is not assigned with any of the subjects of the selected class- Courseware tile is added
                //ISQA bug- #5493 -Developer- Shereen- Date : 23/12/2017
                if (coursewareObj.mark_entry_obj) {
                    _.each(coursewareObj.mark_entry_obj, function (each) {
                        coursewareList.push(each)
                    })
                }
                if (coursewareList.length > 0) {
                    var dataList = _.filter(coursewareList, function (obj) {
                        return obj.class_id === academics.class_id && obj.curriculum_id === academics.curriculum_id && obj.batch_id === academics.batch_id && obj.session_id === academics.session_id && obj.subject_id === academics.subject_id
                    })
                    var roles = []
                    if (dataList && dataList.length > 0) {
                        _.each(dataList, function (each) {
                            if (each.assign_roles != undefined) {
                                if (each.assign_roles.length > 0) {
                                    var roleList = _.union(each.assign_roles, roles);
                                    roles = roleList;
                                }
                            }
                        })
                    }
                }
            }
            return roles
        }

        // function getGmailInboxDetails() {
        //     authService.callAPI(NAVIGATION_CONSTANTS.API_GET_GMAIL_INBOX_DETAILS + localStorageService.get('username') + '/' + localStorageService.get('school_id'), "GET", {}, function (response) {
        //         if (response.result && response.result.data) {
        //             try {
        //                 $scope.gmailInboxDetails = response.result.data.details;
        //             } catch (ex) {
        //                 console.log(ex);
        //             }
        //         }
        //         _.defer(function () {
        //             $scope.$apply();
        //         });
        //     });
        // }

        $scope.goToEmail = function () {
            $state.go('gmail');
        }
        $scope.maskLogin = function () {
            $mdDialog.show({
                controller: MaskLoginPreviewController,
                template: templateMaskLogin,
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                escapeToClose: true
            })
        }
       function MaskLoginPreviewController($scope, $mdDialog, $timeout) {
            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };
            $scope.triggersubmitMask = function () {
                $timeout(function () {
                    angular.element('#dicbtnMask').triggerHandler('click');
                    document.querySelector("#dicbtnMask").focus();
                });
            }

            $scope.goToMaskedLoginFn = (maskemailId) => {
                document.getElementById("issearchimg").style.display = "block";
                if (maskemailId) {
                    let maskEmail = maskemailId.toLowerCase();
                    console.log(maskEmail)
                    if(maskEmail.match(
                        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                      )){
                        if(localStorageService.get('username') == maskEmail){
                          document.getElementById("issearchimg").style.display = "none";
                          toastr.error("Can't mask own email Id.");
                        } else {
                            let logData = {
                                username: maskEmail,
                                school_id: localStorageService.get('school_id'),
                                masked_user: localStorageService.get('username'),
                                userAgent: "web"
                            };
                        // valid Email Id ... Start Login function Satrt..........................................
                        if (logData) {
                            $state.go("dashboard");
                            authService.callAPI("/v1/mask_login_auth", "POST", logData, function (response) {
                            if (response.result != undefined) {
                                localStorage.clear();
                                let result = response.result.data.data[0]
                                console.log(result)
                                try {
                                    if(response.result.data.sessionId != undefined){
                                        localStorageService.set("sessionId", response.result.data.sessionId);
                                    }
                                    var empOrAdmnNo = result.admission_number ? result.admission_number : result.employeeNo
                                    var userBatchDetails = result.name
                                    if (result.admission_number)
                                        userBatchDetails = result.sessionName + "/" + result.curriculumName + "/" + result.className + "/" + result.batchName + "/" + result.name
                                    _paq.push(['setCustomDimension', 1, "School ID", result.school_name]);
                                    _paq.push(['setCustomDimension', 2, "Role IDs", result.role_ids]);
                                    _paq.push(['setCustomDimension', 3, "Login Username", result.quick_login_id]);
                                    _paq.push(['setCustomDimension', 4, "AdmnNo-EmpNo", empOrAdmnNo]);
                                    _paq.push(['setCustomDimension', 5, "User Details", userBatchDetails]);
                                    _paq.push(['setUserId', result.username]);
                                    _paq.push(['trackPageView']);
                                } catch (e) {
                                    console.log(e);
                                }
                                // matomo analytics code ends
                                localStorageService.set("masked_user", result.masked_user)
                                localStorageService.set("loListPopupShown", true)
                                localStorageService.set("allAcademic_year", result.allAcademic_year)
                                localStorageService.set("is_login", true)
                                localStorageService.set("school_id", result.school_id)
                                localStorageService.set("school_name", result.school_name)
                                localStorageService.set("school_logo", result.school_logo)
                                localStorageService.set("academic_year", result.academic_year)
                                localStorageService.set("user_id", result.user_id)
                                localStorageService.set("role_ids", result.role_ids)
                                localStorageService.set("full_name", result.name)
                                localStorageService.set("activeAcdYear", result.academic_year)
                                localStorageService.set("admission_no", result.admission_number)
                                localStorageService.set("username", result.username)
                                localStorageService.set("user_image", result.image)
                                localStorageService.set("active_time_check", result.active_time_check)
                                localStorageService.set('login_timestamp', new Date().getTime());
                                localStorageService.set("full_name", result.name)
                                localStorageService.set("mobile", result.phone)
                                localStorageService.set("user_address", result.addrLine1+","+result.addrLine2+","+result.city+","+result.country)
                                localStorageService.set("module_privileges", result.module_privileges)
                                localStorageService.set("feature_privileges", result.feature_privileges)
                                $rootScope.username = result.name
                                let userAccessJson = _.filter(localStorageService.get('feature_privileges'), function (feature) {
                                    return feature.module_state === "childrenComponent"
                                });
                                if (userAccessJson && userAccessJson.length) {
                                    _.each(userAccessJson, function (feature) {
                                        let user_access = {};
                                        _.each(feature.privilege, function (privObj) {
                                            user_access[privObj.name.toLowerCase()] = privObj.status
                                        })
                                        localStorageService.set('parent_user_access', user_access);
                                        $rootScope.userRoleParentAccess = localStorageService.get('parent_user_access');
                                        _.defer(function () {
                                            $scope.$apply();
                                        });;
                                    })
                                }
                                $rootScope.isLoggedIn = true
                                if (result && result.new_users && result.new_users.length
                                    && result.new_users.includes(result.username)) {
                                    localStorageService.set("loListPopupShown", false)
                                }
                                if(result && result.new_users && result.new_users.length
                                     && result.new_users.includes(result.username)){
                                     localStorageService.set("dataEntryUserLogin", true)
                                     $state.go('menutile')
                                     $mdDialog.hide();
                                     _.defer(function () {
                                        $scope.$apply();
                                    });
                                     return
                                }
                                // $scope.onlyAdvertisementAccess = false;                  //////hiding the back and home buttons
                                // Check for only Advertisement_ID access
                                // let featurePrivileges = result.feature_privileges || []; //ads page only access checking
                                // let isOnlyAdvertisementAccess = (
                                //     featurePrivileges.length === 1 &&
                                //     featurePrivileges[0].feature_id === "Advertisement_ID"
                                // );

                                // if (isOnlyAdvertisementAccess) { //ads page only access checking if yes directly navigate user to ads page.
                                //     // $scope.onlyAdvertisementAccess = true;               ////hiding bakc and home buttons
                                //     $state.go("advertisementCtrl"); 
                                //     $mdDialog.hide();
                                //     _.defer(function () {
                                //         $scope.$apply();
                                //     });
                                //     return;
                                // }
                                location.reload();
                            } else {
                                    let msg = response.error.error.message
                                    toastr.error(msg);
                            }
                            document.getElementById("issearchimg").style.display = "none";
                            })

                            }
                        // valid Email Id ... Start Login function End..........................................
                        }
                      } else {
                        document.getElementById("issearchimg").style.display = "none";
                        toastr.error('Invalid email Id. Please enter valid email Id.');
                      }
                } else {
                    document.getElementById("issearchimg").style.display = "none";
                    toastr.error('Please enter valid email Id.');
                }
            }
        }


        $scope.goToUnMaskedLoginFn = (maskemailId) => {
            if (maskemailId) {
                let maskEmail = maskemailId.toLowerCase();
                console.log(maskEmail);
                if(maskEmail.match(
                    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                  )){
                    let logData = {
                        username: maskEmail,
                        school_id: localStorageService.get('school_id'),
                        masked_user: localStorageService.get('username'),
                        userAgent: "web"
                    };
                   // valid Email Id ... Start Login function Satrt..........................................
                   if (logData) {
                    document.getElementById("unmask1").style.display = "none";
                    document.getElementById("unmask2").style.display = "block";
                    $state.go("dashboard");
                    authService.callAPI("/v1/mask_login_auth", "POST", logData, function (response) {
                       if (response.result != undefined) {
                           localStorage.clear();
                           let result = response.result.data.data[0]
                           console.log(result)
                           try {
                               if(response.result.data.sessionId != undefined){
                                   localStorageService.set("sessionId", response.result.data.sessionId);
                               }
                               var empOrAdmnNo = result.admission_number ? result.admission_number : result.employeeNo
                               var userBatchDetails = result.name
                               if (result.admission_number)
                                   userBatchDetails = result.sessionName + "/" + result.curriculumName + "/" + result.className + "/" + result.batchName + "/" + result.name
                               _paq.push(['setCustomDimension', 1, "School ID", result.school_name]);
                               _paq.push(['setCustomDimension', 2, "Role IDs", result.role_ids]);
                               _paq.push(['setCustomDimension', 3, "Login Username", result.quick_login_id]);
                               _paq.push(['setCustomDimension', 4, "AdmnNo-EmpNo", empOrAdmnNo]);
                               _paq.push(['setCustomDimension', 5, "User Details", userBatchDetails]);
                               _paq.push(['setUserId', result.username]);
                               _paq.push(['trackPageView']);
                           } catch (e) {
                               console.log(e);
                           }
                           // matomo analytics code ends
                        //    localStorageService.set("masked_user", result.masked_user)
                           localStorageService.set("allAcademic_year", result.allAcademic_year)
                           localStorageService.set("is_login", true)
                           localStorageService.set("school_id", result.school_id)
                           localStorageService.set("school_name", result.school_name)
                           localStorageService.set("school_logo", result.school_logo)
                           localStorageService.set("academic_year", result.academic_year)
                           localStorageService.set("user_id", result.user_id)
                           localStorageService.set("role_ids", result.role_ids)
                           localStorageService.set("full_name", result.name)
                           localStorageService.set("activeAcdYear", result.academic_year)
                           localStorageService.set("admission_no", result.admission_number)
                           localStorageService.set("username", result.username)
                           localStorageService.set("user_image", result.image)
                           localStorageService.set("active_time_check", result.active_time_check)
                           localStorageService.set('login_timestamp', new Date().getTime());
                           localStorageService.set("full_name", result.name)
                           localStorageService.set("mobile", result.phone)
                           localStorageService.set("user_address", result.addrLine1+","+result.addrLine2+","+result.city+","+result.country)
                           localStorageService.set("module_privileges", result.module_privileges)
                           localStorageService.set("feature_privileges", result.feature_privileges)
                           $rootScope.username = result.name
                           let userAccessJson = _.filter(localStorageService.get('feature_privileges'), function (feature) {
                               return feature.module_state === "childrenComponent"
                           });
                           if (userAccessJson && userAccessJson.length) {
                               _.each(userAccessJson, function (feature) {
                                   let user_access = {};
                                   _.each(feature.privilege, function (privObj) {
                                       user_access[privObj.name.toLowerCase()] = privObj.status
                                   })
                                   localStorageService.set('parent_user_access', user_access);
                                   $rootScope.userRoleParentAccess = localStorageService.get('parent_user_access');
                                   _.defer(function () {
                                       $scope.$apply();
                                   });;
                               })
                           }
                           $rootScope.isLoggedIn = true
                           location.reload();
                       } else {
                            let msg = response.error.error.message
                            toastr.error(msg);
                       }
                       document.getElementById("issearchimg").style.display = "none";
                    })

                    }
                   // valid Email Id ... Start Login function End..........................................

                  } else {
                    document.getElementById("issearchimg").style.display = "none";
                    toastr.error('Invalid email Id. Please enter valid email Id.');
                  }
            } else {
                document.getElementById("issearchimg").style.display = "none";
                toastr.error('Please enter valid email Id.');
            }
        }


        this.$onDestroy = () => {
            $scope.moreOptionList = []
        }
    }
}

export default NavigationController;



// WEBPACK FOOTER //
// ./src/app/navigation/controllers/navigationController.js